<template>
  <div ref="scollElement">
    <div class="t_header" v-if="w_width<888">
      <div class="fx_cs t_topbar">
        <img src="../assets/img/homepage/logotop.png" style="height: 28px" />
        <i class="iconfont iconzu1714" style="color: #FFFFFF" @click="change()"></i>
      </div>
      <div class="t_maindiv1">
        <img src="/img/bg1.da3a8e6e.jpg">
        <div class="t_maintxt1">
          <div>提供专业、可信赖的<br>信息化产品服务</div>
          <div>让您的企业生产过程更高效、更安全、更智能</div>
          <div class="t_mainbtn">
            <i class="iconfont iconzu1250"></i>0513-81193001
          </div>
        </div>
      </div>
    </div>
    <div class="header" v-else>
      <div class="topbar">
        <img src="../assets/img/homepage/logotop.png" />
        <myheader></myheader>
      </div>
      <div class="maindiv1">
        <span class="mainsp1">提供专业、可信赖的信息化产品服务</span><br />
        <span class="mainsp2">让您的企业生产过程更高效、更安全、更智能</span
        ><br />
        <div class="mainbtn">
          <i class="iconfont iconzu1250"></i>咨询热线：0513-81193001
        </div>
      </div>
    </div>
    <div class="t_bcgray" v-if="w_width<888">
      <div class="t_sp1">TMIP产品体系</div>
      <div class="t_sp2">
        TMIP Ver 4.0<br>针对生产管理的各个环节提供专业、可靠的解决方案
      </div>
      <div class="t_maindiv2">
        <div>
          <div class="fx_cs t_sp3" @click="proShow[0].flag=!proShow[0].flag">
            <span>MES 生产管理</span>
            <i class="iconfont iconlujing3278 t_icon2"></i>
          </div>
          <div class="t_maindiv3 t_animation" v-show="proShow[0].flag">
            <div>
              <img src="/img/1.c96c0c9a.png">
            </div>
            <div>
              针对纺织印染企业的生产过程特点，以生产计划排程、工艺质量控制、品种成本核算、智慧仓储为主要核心模块，推出的生产管理平台
            </div>
            <div @click="goto('/mes')">
              了解详情<i class="iconfont iconzu353" style="margin-left:10px;font-size: 12px"></i>
            </div>
          </div>
        </div>
        <div>
          <div class="fx_cs t_sp3" @click="proShow[1].flag=!proShow[1].flag">
            <span>WMS 智慧仓储</span>
            <i class="iconfont iconlujing3278 t_icon2"></i>
          </div>
          <div class="t_maindiv3 t_animation2" v-show="proShow[1].flag">
            <div>
              <img src="/img/2.d5a8e69d.png">
            </div>
            <div>
              根据实际货物存储要求（集中存放、先进先出等），由系统自动规划入仓存放、出仓配货库位。基于3D虚拟现实技术，实现仓库的可视化管理，快速定位，提升作业效率
            </div>
            <div  @click="goto('/wms')">
              了解详情<i class="iconfont iconzu353" style="margin-left:10px;font-size: 12px"></i>
            </div>
          </div>
        </div>
        <div>
          <div class="fx_cs t_sp3" @click="proShow[2].flag=!proShow[2].flag">
            <span>MTR 物料溯源</span>
            <i class="iconfont iconlujing3278 t_icon2"></i>
          </div>
          <div class="t_maindiv3 t_animation2" v-show="proShow[2].flag">
            <div>
              <img src="/img/3.23806ca2.png">
            </div>
            <div>
              应用生产过程中的物料标签（条码、RFID），从原料投入开始，包括中间工序在内，通过移动掌机记录工序投入、产出物料标签，实现产成品溯源的目标，提升物料质量管理水平
            </div>
            <div @click="goto('/mtr')">
              了解详情<i class="iconfont iconzu353" style="margin-left:10px;font-size: 12px"></i>
            </div>
          </div>
        </div>
        <div>
          <div class="fx_cs t_sp3" @click="proShow[3].flag=!proShow[3].flag">
            <span>EMV 生产可视化</span>
            <i class="iconfont iconlujing3278 t_icon2"></i>
          </div>
          <div class="t_maindiv3 t_animation2" v-show="proShow[3].flag">
            <div>
              <img src="/img/4.ec101536.png">
            </div>
            <div>
              应用数据孪生技术，对生产过程进行镜像，核验工艺条件参数与设备实际生产参数的一致性，按设定的阈值对结果进行比对、控制，多渠道触达相关人员，提升加工质量管理水平
            </div>
            <div @click="goto('/emv')">
              了解详情<i class="iconfont iconzu353" style="margin-left:10px;font-size: 12px"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bcgray" v-else>
      <div class="widtol maindiv2">
        <span class="mainsp3">TMIP产品体系</span>
        <span class="mainsp4"
          >TMIP Ver 4.0<br />
          针对生产管理的各个环节提供专业、可靠的解决方案</span
        >
        <div class="maindiv3 mainflex">
          <div
            class="maindiv5"
            style="margin-right: 30px"
            @mouseover="animatein1"
            @mouseleave="animateout1"
            @click="goto('/mes')"
          >
            <transition enter-active-class="animated  zoomIn" leave-active-class="animated  zoomOut">
              <div class="maindiv7" v-show="show1">
                <span class="mainsp6">MES 生产管理</span>
                <span class="mainsp7"
                  >针对纺织印染企业的生产过程特点，以生产计划排程、工艺质量控制、品种成本核算、智慧仓储为主要核心模块，推出的生产管理平台。</span>
                <i class="iconfont iconzu353"></i>
              </div>
            </transition>
            <transition enter-active-class="animated  zoomIn" leave-active-class="animated  zoomOut">
              <div class="maindiv6" v-show="!show1">
                <img src="../assets/img/homepage/1.png" />
                <span class="mainsp5">MES 生产管理</span>
              </div>
            </transition>
          </div>
          <div
            class="maindiv5"
            @mouseover="animatein2"
            @mouseleave="animateout2"
            @click="goto('/wms')"
          >
            <transition enter-active-class="animated  zoomIn" leave-active-class="animated  zoomOut">
              <div class="maindiv7" v-show="show2">
                <span class="mainsp6">WMS 智慧仓储</span>
                <span class="mainsp7"
                  >根据实际货物存储的要求（集中存放、先进先出等），
                  由系统自动规划入仓存放、出仓配货库位。
                  基于3D虚拟现实技术，实现3D仓库的可视化管理，
                  快速定位，提升作业效率。</span
                >
                <i class="iconfont iconzu353"></i>
              </div>
            </transition>
            <transition enter-active-class="animated  zoomIn" leave-active-class="animated  zoomOut">
              <div class="maindiv6" v-show="!show2">
                <img src="../assets/img/homepage/2.png" />
                <span class="mainsp5">WMS 智慧仓储</span>
              </div>
            </transition>
          </div>
        </div>
        <div class="maindiv4 mainflex">
          <div
            class="maindiv5"
            style="margin-right: 30px"
            @mouseover="animatein3"
            @mouseleave="animateout3"
            @click="goto('/mtr')"
          >
            <transition enter-active-class="animated  zoomIn" leave-active-class="animated  zoomOut">
              <div class="maindiv7" v-show="show3">
                <span class="mainsp6">MTR 物料溯源</span>
                <span class="mainsp7"
                  >应用生产过程中的物料标签（条码、RFID），
                  从原料投入开始，包括中间工序在内，
                  通过移动掌机记录工序投入、产出物料标签，
                  从而实现产成品溯源的目标，提升物料质量管理水平。</span
                >
                <i class="iconfont iconzu353"></i>
              </div>
            </transition>
            <transition enter-active-class="animated  zoomIn" leave-active-class="animated  zoomOut">
              <div class="maindiv6" v-show="!show3">
                <img src="../assets/img/homepage/3.png" />
                <span class="mainsp5">MTR 物料溯源</span>
              </div>
            </transition>
          </div>
          <div
            class="maindiv5"
            @mouseover="animatein4"
            @mouseleave="animateout4"
            @click="goto('/emv')"
          >
          <transition enter-active-class="animated  zoomIn" leave-active-class="animated  zoomOut">
            <div class="maindiv7" v-show="show4">
              <span class="mainsp6">EMV 生产可视化</span>
              <span class="mainsp7"
                >应用数据孪生技术，对生产过程进行镜像，
                核验工艺条件参数与设备实际生产参数的一致性，
                按设定的阈值对结果进行比对、控制，
                多渠道触达相关人员，提升加工质量管理水平。</span
              >
              <i class="iconfont iconzu353"></i>
            </div>
            </transition>
            <transition enter-active-class="animated  zoomIn" leave-active-class="animated  zoomOut">
              <div class="maindiv6" v-show="!show4">
                <img src="../assets/img/homepage/4.png" />
                <span class="mainsp5">EMV 生产可视化</span>
              </div>
            </transition>
            
          </div>
        </div>
      </div>
    </div>
    <div class="t_bcWhite" v-if="w_width<888">
      <div class="t_txt5">我们的客户</div>
      <div class="t_txt6">
        已为多家大型生产型企业提供信息化服务，<br>深入了解企业管理痛点，提出信息化解决方案。 <br>
        通过信息化手段，实现生产进度可跟踪、生产品质可追溯、生产成本可分析，为企业提供安全可靠的数据分析平台
      </div>
      <div style="width: 93.4%;margin: 0 0 0 3.3%">
        <img :src="item.img" v-for="(item,index) in compsList" :key="index" style="width: 34.2%;margin: 10px 7.9%">
      </div>
    </div>
    <div class="bcwhite" v-else>
      <div class="widtol maindiv8">
        <span class="mainsp8">我们的客户</span>
        <span class="mainsp9">已为多家大型生产型企业提供信息化服务，深入了解企业管理痛点，提出信息化解决方案。
          <br> 通过信息化手段，实现生产进度可跟踪、生产品质可追溯、生产成本可分析，为企业提供安全可靠的数据分析平台。</span>
        <div class="maindiv9">
          <div class="maindiv10" v-for="(item,index) in compsList" :key="index">
            <img :src="item.img">
            <transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOut">
              <div class="maindiv11" >
                <span class="mainsp10">{{item.content}}</span>
                <div class="maindiv12"></div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <div class="t_bcgray" style="padding: 37px 0" v-if="w_width<888">
      <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="t_txt4">阶段一：需求确认</div>
              <img src="../assets/img/homepage/c1.jpg" style="width: 100%;margin: 40px 0 8px 0">
              <div class="fx_cs">
                <div>
                  <div class="t_icon4">
                    <div class="t_maindiv21">
                      <i class="iconfont iconzu1260 mainicon"></i>
                    </div>
                    <span class="t_txt7">需求调研</span>
                  </div>
                  <div class="t_icon4">
                    <div class="t_maindiv21">
                      <i class="iconfont iconzu1261 mainicon"></i>
                    </div>
                    <span class="t_txt7">合同签订</span>
                  </div>
                </div>
                <div>
                  <div class="t_icon4">
                    <div class="t_maindiv21">
                      <i class="iconfont iconzu1259 mainicon"></i>
                    </div>
                    <span class="t_txt7">方案及预算</span>
                  </div>
                  <div class="t_icon4">
                    <div class="t_maindiv21">
                      <i class="iconfont iconlujing3280 mainicon"></i>
                    </div>
                    <span class="t_txt7">制定项目计划</span>
                  </div>
                </div>
              </div>
              <div class="t_icon4">
                <div class="t_maindiv21">
                  <i class="iconfont iconlujing3280 mainicon"></i>
                </div>
                <span class="t_txt7">制定项目计划</span>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="t_txt4">阶段二：项目研发</div>
              <img src="../assets/img/homepage/c2.jpg" style="width: 100%;margin: 40px 0 8px 0">
              <div class="fx_cs">
                <div class="t_icon4">
                  <div class="t_maindiv21">
                    <i class="iconfont iconlujing3279 mainicon"></i>
                  </div>
                  <span class="t_txt7">功能研发</span>
                </div>
                <div class="t_icon4">
                  <div class="t_maindiv21">
                    <i class="iconfont iconzu1258 mainicon"></i>
                  </div>
                  <span class="t_txt7">项目测试</span>
                </div>
              </div>
              <div class="t_txt8">
                每周输出项目进度报告<br>帮助客户实时了解研发进度
              </div>
            </div>
            <div class="swiper-slide">
              <div class="t_txt4">阶段三：交付验收</div>
              <img src="../assets/img/homepage/c3.jpg" style="width: 100%;margin: 40px 0 8px 0">
              <div class="fx_cs">
                <div class="t_icon4">
                  <div class="t_maindiv21">
                    <i class="iconfont iconlujing3281 mainicon"></i>
                  </div>
                  <span class="t_txt7">实施交付</span>
                </div>
                <div class="t_icon4">
                  <div class="t_maindiv21">
                    <i class="iconfont iconzu1263 mainicon"></i>
                  </div>
                  <span class="t_txt7">使用培训</span>
                </div>
              </div>
              <div class="t_txt8">
                根据阶段一的功能设计书进行功能验收<br>验收条目清晰可查
              </div>
            </div>
            <div class="swiper-slide">
              <div class="t_txt4">阶段四：运维支持</div>
              <img src="../assets/img/homepage/c4.jpg" style="width: 100%;margin: 40px 0 8px 0">
              <div class="fx_cs">
                <div class="t_icon4">
                  <div class="t_maindiv21">
                    <i class="iconfont iconlujing3283 mainicon"></i>
                  </div>
                  <span class="t_txt7">专属客户<br>经理对接</span>
                </div>
                <div class="t_icon4">
                  <div class="t_maindiv21">
                    <i class="iconfont iconlujing3282 mainicon"></i>
                  </div>
                  <span class="t_txt7">工作日<br>24小时响应</span>
                </div>
              </div>
              <div class="t_txt8">
                将反馈内容登记到课题表<br>每周进行跟进汇报
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="bcgray" v-else>
      <div class="widtol maindiv13">
        <span class="mainsp8" style="margin-bottom:18px">服务流程</span>
        <span class="mainsp9" style="font: normal normal normal 20px/32px Microsoft YaHei;">无缝对接、专业服务流程</span>
        <div class="maindiv14">
          <div v-for="(show,idx) in shows" :key="idx">
            <div class="maindiv15" @click="addclass(idx)" :class="selectedshow == idx ?'selected':''">
              <img :src="show.img">
            </div>
            <span class="mainsp11">{{show.content}}</span>
          </div>
        </div>
        <!-- 需求确认 -->
        <div class="maindiv16" v-show="selectedshow == '0'">
          <div class="maindiv17">
            <div class="maindiv18">
              <img src="../assets/img/homepage/c1.jpg">
            </div>
            
            <div class="maindiv19">
              <el-row class="maindiv20">
                <el-col :span="10">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconzu1260 mainicon"></i>
                    </div>
                    <span class="mainsp12">需求调研</span>
                  </div>
                </el-col>
                <el-col :span="2">
                  <i class="el-icon-arrow-right mainicon1"></i>
                </el-col>
                <el-col :span="9" :push="3">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconzu1259 mainicon"></i>
                    </div>
                    <span class="mainsp12">方案及预算</span>
                  </div>
                </el-col>
              </el-row>
              <el-row  class="maindiv20">
                <el-col :span="10">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconzu1261 mainicon"></i>
                    </div>
                    <span class="mainsp12">合同签订</span>
                  </div>
                </el-col>
                <el-col :span="2">
                  <i class="el-icon-arrow-right mainicon1"></i>
                </el-col>
                <el-col :span="9" :push="3">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconlujing3280 mainicon"></i>
                    </div>
                    <span class="mainsp12">制定项目计划</span>
                  </div>
                </el-col>
              </el-row>
              <el-row  class="maindiv20">
                <el-col :span="24">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconzu1262 mainicon"></i>
                    </div>
                    <span class="mainsp12">交互设计书 / 功能设计书</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <!-- 项目研发 -->
        <div class="maindiv16" v-show="selectedshow == '1'">
          <div class="maindiv17">
            <div class="maindiv18">
              <img src="../assets/img/homepage/c2.jpg">
            </div>
            
            <div class="maindiv19">
              <el-row class="maindiv20">
                <el-col :span="10">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconlujing3279 mainicon"></i>
                    </div>
                    <span class="mainsp12">功能研发</span>
                  </div>
                </el-col>
                <el-col :span="2">
                  <i class="el-icon-arrow-right mainicon1"></i>
                </el-col>
                <el-col :span="9" :push="3">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconzu1258 mainicon"></i>
                    </div>
                    <span class="mainsp12">项目测试</span>
                  </div>
                </el-col>
              </el-row>
              <el-row  class="maindiv20">
                <el-col :span="24" style="padding:0 10px">
                  <span class="mainsp13">在项目研发阶段，每周输出项目进度报告，帮助客户实时<br>了解研发进度</span>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <!-- 交付验收 -->
        <div class="maindiv16" v-show="selectedshow == '2'">
          <div class="maindiv17">
            <div class="maindiv18">
              <img src="../assets/img/homepage/c3.jpg">
            </div>
            
            <div class="maindiv19">
              <el-row class="maindiv20">
                <el-col :span="10">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconlujing3281 mainicon"></i>
                    </div>
                    <span class="mainsp12">实施交付</span>
                  </div>
                </el-col>
                <el-col :span="2">
                  <i class="el-icon-arrow-right mainicon1"></i>
                </el-col>
                <el-col :span="9" :push="3">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconzu1263 mainicon"></i>
                    </div>
                    <span class="mainsp12">使用培训</span>
                  </div>
                </el-col>
              </el-row>
              <el-row  class="maindiv20">
                <el-col :span="24" style="padding:0 10px">
                  <span class="mainsp13">在实施交付阶段，根据阶段一的功能设计书进行<br>功能验收，验收条目清晰可查</span>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <!-- 运维支持 -->
        <div class="maindiv16" v-show="selectedshow == '3'">
          <div class="maindiv17">
            <div class="maindiv18">
              <img src="../assets/img/homepage/c4.jpg">
            </div>
            
            <div class="maindiv19">
              <el-row class="maindiv20">
                <el-col :span="12">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconlujing3283 mainicon"></i>
                    </div>
                    <span class="mainsp12">专属客户经理对接</span>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="maindiv22">
                    <div class="maindiv21">
                      <i class="iconfont iconlujing3282 mainicon"></i>
                    </div>
                    <span class="mainsp12">工作日24小时响应</span>
                  </div>
                </el-col>
              </el-row>
              <el-row  class="maindiv20">
                <el-col :span="24" style="padding:0 10px">
                  <span class="mainsp13">在实施交付阶段，根据阶段一的功能设计书进行功能验收，验收条目清晰可查</span>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!---首页弹出----->
    <mt-popup
      v-model="boxShow"
      position="right">
      <div style="display: block;padding: 40px 7%;" :style="{width:w_width+'px',height:w_height+'px'}">
        <div style="text-align: right">
          <span style="font-size: 25px" @click="boxShow=false">✕</span>
        </div>
        <div class="t_list" @click="boxShow=false">首页</div>
        <div class="t_list fx_cs" @click="listShow=true">
          TMIP产品体系
          <i class="iconfont iconlujing3278 t_icon2"></i>
        </div>
        <div v-show="listShow">
          <div class="t_t_list" @click="goto('/mes')">MES 生产管理</div>
          <div class="t_t_list" @click="goto('/wms')">WMS 智慧仓储</div>
          <div class="t_t_list" @click="goto('/mtr')">MTR 物料溯源</div>
          <div class="t_t_list" @click="goto('/emv')">EMV 生产可视化</div>
        </div>
        <div class="t_list" @click="goto('/service')">服务与支持</div>
        <div class="t_list" style="border: 0" @click="goto('/aboutus')">关于我们</div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import util from "../components/util";
import Swiper from "swiper";
export default util.useCommon({
  data() {
    return {
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      selectedshow:'0',
      compsList:[
        {
          img:require ('../assets/img/homepage/a1.jpg'),
          content:'帝人集团',
        },
        {
          img:require ('../assets/img/homepage/a2.jpg'),
          content:'东丽集团'
        },
        {
          img:require ('../assets/img/homepage/a3.jpg'),
          content:'OKI'
        },
        {
          img:require ('../assets/img/homepage/a4.jpg'),
          content:'王子制纸'
        },
        {
          img:require ('../assets/img/homepage/a5.jpg'),
          content:'万方'
        },
        {
          img:require ('../assets/img/homepage/a6.jpg'),
          content:'凯尔文'
        },
        {
          img:require ('../assets/img/homepage/a7.jpg'),
          content:'东隆集团'
        },
        {
          img:require ('../assets/img/homepage/a8.jpg'),
          content:'远吉织染'
        },
        {
          img:require ('../assets/img/homepage/a9.jpg'),
          content:'格林兰'
        },
        {
          img:require ('../assets/img/homepage/a10.jpg'),
          content:'宇泽印染'
        },
        {
          img:require ('../assets/img/homepage/a11.jpg'),
          content:'ANS株式会社'
        },
        {
          img:require ('../assets/img/homepage/a12.jpg'),
          content:'南华纺织'
        },
      ],
      shows: [
        {
          img:require('../assets/img/homepage/b1.png'),
          content:'需求确认'
        },
        {
          img:require('../assets/img/homepage/b2.png'),
          content:'项目研发'
        },
        {
          img:require('../assets/img/homepage/b3.png'),
          content:'交付验收'
        },
        {
          img:require('../assets/img/homepage/b4.png'),
          content:'运维支持'
        },
      ],
      w_width:0,
      activeNames:1,
      proShow:[{flag:false},{flag:false},{flag:false},{flag:false}],
      boxShow: false,
      listShow:true,
      w_height:0,
    };
  },
  watch: {},
  methods: {
    goto(add) {
      this.backtop();
      this.$router.push(add);
    },
    backtop() {
      this.$emit('gotoTop');
      // this.$nextTick(() => {
      //   if (this.$refs.scollElement) {
      //     // 滚动元素跳转到顶部
      //     this.$refs.scollElement.scrollTop = -520;
      //   }
      // });
    },
    addclass(idx){
      var v = this;
      v.selectedshow = idx;
    },
    animatein1() {
      this.show1 = true;
    },
    animateout1() {
      this.show1 = false;
    },
    animatein2() {
      this.show2 = true;
    },
    animateout2() {
      this.show2 = false;
    },
    animatein3() {
      this.show3 = true;
    },
    animateout3() {
      this.show3 = false;
    },
    animatein4() {
      this.show4 = true;
    },
    animateout4() {
      this.show4 = false;
    },
    change(){
      this.boxShow = true;
      console.log(this.boxShow);
    }
  },
  mounted() {
    console.log(window.innerWidth);
    this.w_width = window.innerWidth;
    this.w_height = window.innerHeight;
    var swiper = new Swiper('.swiper-container', {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 24,
      autoplay: {
        disableOnInteraction: false,
        delay: 2000,
      },
    });
  },
  activated() {},
});
</script>
<style lang="less" scoped>
.header {
  background-image: url(../assets/img/homepage/bg1.jpg);
  min-width: 1300px; 
}
.maindiv1 {
  text-align: center;
  padding-top: 170px;
}
.mainsp1 {
  font: normal normal normal 46px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}
.mainsp2 {
  font: normal normal 300 24px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  display: inline-block;
  margin: 30px 0 50px 0;
}
.mainbtn {
  font: normal normal normal 18px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  width: 320px;
  margin: 0 auto;
  background-color: #537bfe;
  border-radius: 27px;
  overflow: hidden;
  cursor: default;
}

.iconzu1250 {
  margin-right: 10px;
  font-size: 20px;
  position: relative;
  top: 2px;
}

.maindiv2 {
  padding: 136px 0 148px 0;
  text-align: center;
}

.mainsp3 {
  font: normal normal normal 40px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #333333;
  display: block;
  margin-bottom: 10px;
}
.mainsp4 {
  font: normal normal normal 20px/32px Microsoft YaHei;
  letter-spacing: 0px;
  color: #717b81;
}
.maindiv3 {
  padding-top: 50px;
}
.maindiv4 {
  padding-top: 30px;
}
.mainflex {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin: 0 auto;
}
.maindiv5 {
  width: 528px;
  height: 400px;
  background: #ffffff;
  box-shadow: 0px 0px 6px #3e548229;
  border-radius: 8px;
  position: relative;
  cursor: pointer;
}
.maindiv6 {
  margin: 0 auto;
  padding-top: 60px;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.maindiv6 img {
  width: 200px;
  height: 200px;
}

.mainsp5 {
  display: block;
  margin-top: 35px;
  font: normal normal bold 22px/32px Source Han Sans CN;
  letter-spacing: 0px;
  color: #333333;
}
.maindiv7 {
  width: 100%;
  height: 100%;
  background-color: #536dfe;
  border-radius: 8px;
  position: relative;
  padding: 90px 40px 0;
  text-align: center;
  color: #ffffff;
}
.maindiv7 .iconfont{
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 50px;
  font-size: 26px;
}

.mainsp6 {
  font: normal normal bold 22px/32px Source Han Sans CN;
  letter-spacing: 0px;
  color: #ffffff;
  display: block;
  margin-bottom: 30px;
}
.mainsp7 {
  font: normal normal normal 16px/32px Microsoft YaHei;
  letter-spacing: 0px;
  color: #ffffff;
}


.maindiv8{
  padding: 90px 0 130px;
  text-align: center;
}
.mainsp8{
  font: normal normal normal 40px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #333333;
  display: block;
  margin-bottom: 28px;
}
.mainsp9{
  font: normal normal normal 18px/32px Microsoft YaHei;
  letter-spacing: 0px;
  color: #717B81;
}
.maindiv9{
  display: flex;
  width: 100%;
  padding-top: 50px;
  display: -webkit-flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
.maindiv10{
  width: 156px;
  height: 91px;
  margin-top: 34px;
  border-radius: 8px;
  box-shadow: 0px 0px 6px #3E548229;
  position: relative;
}
.maindiv10 img{
  width: 100%;
  height: 100%;
}
.maindiv11{
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  opacity: 0.9;
  background-color: #536DFE;
  border-radius: 8px;
  display: none;
  white-space: nowrap;
  padding-top: 26px;
}
.maindiv10:hover{
  .maindiv11{
    display: block;
    animation: fade-in;/*动画名称*/  
    animation-duration: .3s;/*动画持续时间*/  
    -webkit-animation:fade-in .3s;/*针对webkit内核*/  
  }

}
.mainsp10{
  font: normal normal 300 18px/30px Microsoft YaHei;
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
}

.maindiv12{
  width: 30px;
  height: 2px;
  background-color: #ffffff;
  margin: 0 auto;
}

@keyframes fade-in {  
    0% {opacity: 0;}/*初始状态 透明度为0*/  
    30% {opacity: 0.5;}
    50% {opacity: 0.7;}/*过渡状态 透明度为0*/  
    80% {opacity: 0.8;}
    100% {opacity: 0.9;}/*结束状态 透明度为1*/  
}  
@-webkit-keyframes fade-in {/*针对webkit内核*/  
    0% {opacity: 0;}  
    30% {opacity: 0.5;}
    50% {opacity: 0.7;}  
    80% {opacity: 0.8;}
    100% {opacity: 0.9;}  
}  

.maindiv13{
  padding: 100px 0;
  text-align: center;
}

.maindiv14{
  padding: 0 20px;
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  overflow: hidden;
}
.maindiv15{
  width: 127px;
  height: 127px;
  border-radius: 50%;
  margin: 34px 0 12px 0;
  // overflow: hidden;
  position: relative;
}
.maindiv15:hover{
  cursor: pointer;
  background-color: #ffffff;
}

.maindiv15 img{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}

.maindiv15::before{
  content: '';
  width: 110px;
  height: 3px;
  background-color: #D8DBEF;
  position: absolute;
  right: -144px;
  top: 50%;
}

.mainsp11{
  font: normal normal bold 22px/30px Source Han Sans CN;
  letter-spacing: 0px;
  color: #333333;
}

.selected{
  border: #536DFE 1px solid;
  background-color: #ffffff;
}

.maindiv16{
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 17px;
  background-color: #ffffff;
  margin-top: 40px;
  padding: 60px 80px;
}
.maindiv17{
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.maindiv18,.maindiv19{
  width: 50%;
}
.maindiv18{
  padding-right: 30px;
}
.maindiv18 img{
  width: 430px;
  height: 240px;
  // width: 100%;
  // height: auto;
}
.maindiv19{
  padding-left: 30px;
}
.maindiv21{
  box-shadow: 0px 3px 6px #6B8DC829;
  background-color: #ffffff;
  display: inline-block;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 12px;
  position: relative;
}
.mainicon{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  font-size: 16px;
  font-weight: bold;
  color: #536DFE;
}
.mainicon1{
  font-size: 20px;
  color: #C5CAE9;
  position: relative;
  top: 10px;
}
.mainsp12{
  font: normal normal bold 18px/26px Source Han Sans CN;
  letter-spacing: 0px;
  color: #333333;
}
.maindiv22{
  display: flex;
  display: -webkit-flex;
  align-items: center;
}
.maindiv20{
  padding: 15px 0 20px;
  text-align: left;
}

.mainsp13{
  font: normal normal normal 15px/28px Microsoft YaHei;
  letter-spacing: 0px;
  color: #717B81;
}
.animation{
  animation:myTab2 1s;
  -webkit-animation:myTab 1s; /*Safari and Chrome*/
  position: absolute;
  top: 0;
}
  
@keyframes  myTab2{
  from{top:  -310px;}
  to{top: 0;}
}
.swiper-container {
  width: 100%;
  height: 490px;
}
.swiper-slide {
  width: 60%;
  width: 84%;
  padding: 45px 8%;
  background: #FFFFFF;
  border-radius: 8px;
  -webkit-box-shadow: 0px 0px 10px #3e548229;
  box-shadow: 0px 0px 10px #3e548229;
  height: 477px;
}
</style>
